import React from 'react';

export default function MenuPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFB6D9] via-[#FFC4E1] to-[#FFD4EC] pt-40 pb-32">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="font-sans text-sm font-semibold tracking-[0.3em] uppercase text-[#8B6F47] mb-6">
            THRIVEROCK MEDICINE 3.0
          </p>
          <h1 className="font-display text-6xl md:text-8xl font-bold text-[#8B6F47] mb-8 tracking-tight">
            The Injector Syd
          </h1>
          <p className="font-display italic text-3xl text-[#8B6F47]/80 font-normal">
            Service Menu
          </p>
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 max-w-6xl mx-auto">
          {/* Left Column */}
          <div className="space-y-16">
            {/* Laser Hair Removal */}
            <div className="bg-[#A8D08D]/90 backdrop-blur-sm p-12 rounded-3xl shadow-xl">
              <h2 className="font-display text-4xl font-bold text-[#1A1A1A] mb-10 tracking-tight">
                Laser Hair Removal
              </h2>
              
              <div className="space-y-5 mb-10">
                <div className="flex justify-between items-center border-b border-white/30 pb-4">
                  <span className="font-sans text-base text-[#1A1A1A] font-semibold">Full Body</span>
                  <span className="font-sans text-base font-bold text-[#1A1A1A]">$300</span>
                </div>
              </div>

              <h3 className="font-sans text-xs font-bold text-[#1A1A1A] mt-10 mb-6 tracking-[0.25em] uppercase">
                Small Areas
              </h3>
              <div className="space-y-4">
                {[
                  { name: 'Underarms', price: '$40' },
                  { name: 'Forehead', price: '$20' },
                  { name: 'Chin', price: '$30' },
                  { name: 'Upper Lip', price: '$20' },
                  { name: 'Hands', price: '$30' },
                  { name: 'Feet', price: '$30' },
                  { name: 'Areola', price: '$30' },
                ].map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center border-b border-white/20 pb-3">
                    <span className="font-sans text-sm text-[#1A1A1A]/90 font-medium">{item.name}</span>
                    <span className="font-sans text-sm font-semibold text-[#1A1A1A]">{item.price}</span>
                  </div>
                ))}
              </div>

              <h3 className="font-sans text-xs font-bold text-[#1A1A1A] mt-10 mb-6 tracking-[0.25em] uppercase">
                Medium Areas
              </h3>
              <div className="space-y-4">
                {[
                  { name: 'Happy Trail', price: '$50' },
                  { name: 'Bikini', price: '$60' },
                  { name: 'Brazilian', price: '$75' },
                  { name: 'Full Face', price: '$60' },
                  { name: 'Chest', price: '$75' },
                  { name: 'Arms', price: '$75' },
                  { name: 'Neck', price: '$50' },
                ].map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center border-b border-white/20 pb-3">
                    <span className="font-sans text-sm text-[#1A1A1A]/90 font-medium">{item.name}</span>
                    <span className="font-sans text-sm font-semibold text-[#1A1A1A]">{item.price}</span>
                  </div>
                ))}
              </div>

              <h3 className="font-sans text-xs font-bold text-[#1A1A1A] mt-10 mb-6 tracking-[0.25em] uppercase">
                Large Areas
              </h3>
              <div className="space-y-4">
                {[
                  { name: 'Abdomen', price: '$100' },
                  { name: 'Back', price: '$100' },
                  { name: 'Buttock', price: '$80' },
                  { name: 'Legs', price: '$100' },
                ].map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center border-b border-white/20 pb-3">
                    <span className="font-sans text-sm text-[#1A1A1A]/90 font-medium">{item.name}</span>
                    <span className="font-sans text-sm font-semibold text-[#1A1A1A]">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-16">
            {/* Weight Loss + Injectables */}
            <div className="bg-[#A8D08D]/90 backdrop-blur-sm p-12 rounded-3xl shadow-xl">
              <h2 className="font-display text-4xl font-bold text-[#1A1A1A] mb-10 tracking-tight">
                Weight Loss + Injectables
              </h2>
              <div className="space-y-4">
                {[
                  { name: 'Tirzepatide', price: '$550-685' },
                  { name: 'Semaglutide', price: '$350-450' },
                  { name: 'Sermorelin Therapy', price: '$250' },
                  { name: 'Testosterone Therapy', price: '$250' },
                  { name: 'Glutathione Injection', price: '$30' },
                  { name: 'B-12 Injection', price: '$10' },
                  { name: 'MIC Injection', price: '$30' },
                  { name: 'IV Therapy', price: '$150+' },
                  { name: 'Chin Filler', price: '$650' },
                  { name: 'Cheek Filler', price: '$800' },
                  { name: 'Lip Filler', price: '$700' },
                  { name: 'Dysport', price: '$600+' },
                ].map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center border-b border-white/20 pb-3">
                    <span className="font-sans text-sm text-[#1A1A1A]/90 font-medium">{item.name}</span>
                    <span className="font-sans text-sm font-semibold text-[#1A1A1A]">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Morpheus8 + IPL + Forma */}
            <div className="bg-[#A8D08D]/90 backdrop-blur-sm p-12 rounded-3xl shadow-xl">
              <h2 className="font-display text-4xl font-bold text-[#1A1A1A] mb-10 tracking-tight">
                Morpheus8 + IPL + Forma
              </h2>
              <div className="space-y-4">
                {[
                  { name: 'Morpheus8 Face', price: 'CALL' },
                  { name: 'Morpheus8 Body', price: 'CALL' },
                  { name: 'Lumecca Small Area', price: '$150' },
                  { name: 'Lumecca Large Area', price: '$250' },
                  { name: 'Forma Face (30 min)', price: '$100' },
                  { name: 'Forma Body (30 min)', price: '$150' },
                ].map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center border-b border-white/20 pb-3">
                    <span className="font-sans text-sm text-[#1A1A1A]/90 font-medium">{item.name}</span>
                    <span className="font-sans text-sm font-semibold text-[#1A1A1A]">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Hydrafacial */}
            <div className="bg-[#A8D08D]/90 backdrop-blur-sm p-12 rounded-3xl shadow-xl">
              <h2 className="font-display text-4xl font-bold text-[#1A1A1A] mb-10 tracking-tight">
                Hydrafacial
              </h2>
              <div className="space-y-4">
                {[
                  { name: 'Signature Hydrafacial', price: 'CALL' },
                  { name: 'Deluxe Hydrafacial', price: 'CALL' },
                  { name: 'Platinum Hydrafacial', price: 'CALL' },
                  { name: 'Scalp Hydrafacial', price: 'CALL' },
                  { name: 'LED Light Therapy (30 min)', price: '$40' },
                  { name: 'Lymphatic Drainage Face', price: '$75' },
                  { name: 'Lymphatic Drainage Body', price: '$100' },
                ].map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center border-b border-white/20 pb-3">
                    <span className="font-sans text-sm text-[#1A1A1A]/90 font-medium">{item.name}</span>
                    <span className="font-sans text-sm font-semibold text-[#1A1A1A]">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Contact Footer */}
        <div className="mt-24 text-center">
          <div className="flex flex-wrap items-center justify-center gap-8 text-[#8B6F47]">
            <a
              href="https://www.instagram.com/theinjectorsyd"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 font-sans text-sm font-semibold hover:text-[#C4A092] transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl w-5 h-5 flex items-center justify-center"></i>
              @TheInjectorSyd
            </a>
            <a
              href="tel:+17022835858"
              className="flex items-center gap-2 font-sans text-sm font-semibold hover:text-[#C4A092] transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-xl w-5 h-5 flex items-center justify-center"></i>
              702-283-5858
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Thriverock+Medicine+Las+Vegas"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 font-sans text-sm font-semibold hover:text-[#C4A092] transition-colors cursor-pointer"
            >
              <i className="ri-map-pin-line text-xl w-5 h-5 flex items-center justify-center"></i>
              Thriverock Medicine
            </a>
          </div>

          <div className="mt-16 flex flex-wrap items-center justify-center gap-6">
            <a
              href="/"
              className="inline-block px-12 py-5 bg-white text-[#8B6F47] font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#F8F5F2] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-xl hover:shadow-2xl hover:scale-105 border-2 border-[#8B6F47]"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Back to Home
            </a>
            <a
              href="tel:+17022835858"
              className="inline-block px-12 py-5 bg-[#C4A092] text-white font-sans text-sm font-semibold tracking-[0.15em] uppercase hover:bg-[#B8968A] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-lg shadow-2xl hover:shadow-3xl hover:scale-105"
            >
              Book Your Appointment
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
